<script lang="ts">
	import { onMount } from 'svelte';
	import LogoCNR from '$components/Navbar/logos/LogoCNR.svelte';
	import LogoUkrainianService from '$components/Navbar/logos/LogoUkrainianService.svelte';
	import LogoCrimeaRealities from '$components/Navbar/logos/LogoCrimeaRealities.svelte';
	import LogoRussianService from '$components/Navbar/logos/LogoRussianService.svelte';
	import LogoCT from '$components/Navbar/logos/LogoCT.svelte';

	// TYPES
	import type { ServiceVersion } from '$types/ServiceVersion';
	import MenuButton from './menu/MenuButton.svelte';

	export let current: ServiceVersion;

	let scrollY = 0;
	let innerHeight = 0;
	let scrollProgress = 0;
	let totalHeight = 0;

	onMount(() => {
		totalHeight = document.body.scrollHeight - innerHeight;
	});

	$: scrollProgress = Math.round((scrollY / totalHeight) * 100);
</script>

<svelte:window bind:scrollY bind:innerHeight />

<nav class="white">
	<div class="page-progress">
		<div class="page-progress-bar" style="width: {scrollProgress}%"></div>
	</div>
	<div class="nav-content">
		<div class="logo-wrapper">
			<div class="logo">
				{#if current.service === 'cnr'}
					<LogoCNR />
				{/if}
				{#if current.service === 'ukrainian'}
					<LogoUkrainianService />
				{/if}
				{#if current.service === 'crimea_realities'}
					<LogoCrimeaRealities />
				{/if}
				{#if current.service === 'russian'}
					<LogoRussianService />
				{/if}
				{#if current.service === 'ct'}
					<LogoCT />
				{/if}
			</div>
		</div>

		<div class="options-wrapper">
			<MenuButton />
		</div>
	</div>
</nav>

<style lang="scss">
	@use '$styles/colors' as *;

	nav {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 63px;
		z-index: 999;
		transition: background 0.3s ease-in-out;
		background: linear-gradient(
			to bottom,
			rgba($rfe-gray-9, 0.7) 0%,
			rgba($rfe-gray-9, 0.55) 30%,
			rgba($rfe-gray-9, 0.35) 60%,
			rgba($rfe-gray-9, 0) 100%
		);

		.page-progress {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 3px;
			background: var(--brand-primary);

			.page-progress-bar {
				position: absolute;
				top: 0;
				left: 0;
				height: 100%;
				background: var(--brand-primary);
				filter: brightness(0.7);
				transition: width 0.3s ease-in-out;
			}
		}

		&.white {
			background: white;
			box-shadow:
				0 0 20px rgba(0, 0, 0, 0.1),
				0 -30px 0 #fff;

			:global(#logo_ct) {
				fill: $ct-primary-plum;
			}

			:global(#torch) {
				fill: $rfe-orange-5;
				opacity: 1;
			}

			:global(#type) {
				fill: #5c666f;
				opacity: 1;
			}
		}

		:global(#logo_ct) {
			fill: white;
		}

		:global(#torch) {
			fill: white;
			opacity: 0.4;
		}

		:global(#type) {
			fill: white;
			opacity: 0.5;
		}
	}

	.nav-content {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;

		.logo-wrapper {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.options-wrapper {
			position: absolute;
			height: 100%;
			right: 0;
			top: 0;
		}
	}

	:global(.logo) {
		width: 134px;
		height: 40px;

		:global(svg) {
			display: block;
			height: 100%;
			width: 100%;
		}
	}
</style>
